import { z } from 'zod';

/** Liste controllate del mondo Cliente. */

export const StatoCliente = z.enum(['Prospect', 'Attivo', 'Perso']);
export type StatoCliente = z.infer<typeof StatoCliente>;

/**
 * Forme giuridiche del cliente: lista *editabile dal cliente*, quindi in DB vive
 * come tabella di lookup. Questi sono i valori di seed iniziale, nel loro ordine.
 */
export const TipologiaCliente = z.enum([
  'SRL',
  'SRLS',
  'SPA',
  'SAPA',
  'SNC',
  'SAS',
  'Soc. Coop.',
  'Consorzio',
  'Ditta Individuale',
  'Professionista',
  'Ente/Associazione',
  'Altro',
]);
export type TipologiaCliente = z.infer<typeof TipologiaCliente>;

export const CanaleAcquisizione = z.enum(['Diretto', 'Esterno']);
export type CanaleAcquisizione = z.infer<typeof CanaleAcquisizione>;

/**
 * Tipologie documento cliente: lista *editabile dal cliente*, quindi in DB vive
 * come tabella di lookup. Questi sono i valori di seed iniziale.
 */
export const TipoDocumentoCliente = z.enum([
  'Visura camerale',
  'Visura catastale',
  'CI legale rappresentante',
  'Codice fiscale legale rappr.',
  'Statuto',
  'Bilancio',
  'Altro',
]);
export type TipoDocumentoCliente = z.infer<typeof TipoDocumentoCliente>;
